export default {
  add: {
    method: 'POST',
    url: '/partner/order/ID/document'
  },
  archive: {
    method: 'DELETE',
    url: '/partner/order/ID/document/archive'
  },
  delete: {
    method: 'DELETE',
    url: '/partner/order/ID/document'
  }
}
